export default "__VITE_ASSET__BsFU$TNl__"